<template>
	<div class="fc-checkout-edit-address">
		<div>
			<label>Edit Address</label>
			<div class="fc-address-form">
				<div>
					<label><span>*</span>FULL NAME</label>
					<input v-model="editAddress.FullName" type="text" />
				</div>
				<div>
					<label><span>*</span>MOBILE NO.</label>
					<input v-model="editAddress.MobileNo" type="text" />
				</div>
				<div>
					<label><span>*</span>POSTAL CODE</label>
					<input @blur="getAddress" v-model="editAddress.PostalCode" maxlength="6" minlength="6" type="text" />
				</div>
				<div>
					<label><span>*</span>UNIT NO.</label>
					<input v-model="editAddress.UnitNo" type="text" />
				</div>
				<div class="fc-address">
					<label>ADDRESS</label>
					<input v-model="editAddress.Address" type="text" />
				</div>
				<div>
					<label>BUILDING NAME</label>
					<input v-model="editAddress.BuildingName" type="text" />
				</div>
			</div>
			<div class="fc-control">
				<a @click="deleteAddress">Delete</a>
				<a @click="save" class="fc-save">SAVE</a>
			</div>
			<div class="fc-close" @click="close"></div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  name: 'checkout-edit-address',
  props: ['editAddress'],
  methods: {
    getAddress: function () {
      if (this.editAddress.PostalCode.length !== 6) {
        $.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        })
        return
      }
      this.$store.dispatch('address/getAddress', this.editAddress.PostalCode)
    },
    close () {
      this.$emit('close')
    },
    deleteAddress () {
      if (process.browser) {
        const _this = this
        $.confirm({
          title: 'Warning',
          content: 'Remove this item?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function () {
                _this.$store.dispatch('customer/removeAddress', _this.editAddress)
                  .then(() => {
                    _this.$emit('close')
                  })
              }
            },
            close: function () {
            }
          }
        })
      }
    },
    save () {
      if (this.editAddress.PostalCode.length !== 6) {
        $.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        })
        return
      }
      this.$store.dispatch('customer/editAddress', this.editAddress)
        .then(() => {
          this.$emit('close')
        })
    }
  },
  computed: {
    ...mapGetters('address', ['address'])
  },
  watch: {
    address () {
      this.editAddress.Address = this.address.ADDRESS
    }
  }
}
</script>
<style scoped lang="less">
.fc-checkout-edit-address{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(17, 17, 17, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  >div{
  	position:relative;
    border-radius: 3px;
    background-color: #ffffff;
    width: 100%;
    max-width: 600px;
    padding: 32px;
    >label{
	    font-size: 16px;
	    font-weight: bold;
	    color: #111111;
    }
    >.fc-address-form{
    	display: flex;
	    justify-content: space-between;
	    flex-wrap: wrap;
	    margin:12px 0;
	    >div{
	    	width: 49%;
	    	margin: 10px 0;
	    	&.fc-address{
	    		width: 100%;
	    	}
	    	>label{
	    		font-size: 10px;
			    font-weight: 500;
			    line-height: 2.1;
			    letter-spacing: 1px;
			    color: #979797;
			    display: block;
			    >span{
	    	    font-size: 12px;
				    font-weight: bold;
				    line-height: 1.75;
				    letter-spacing: 1.2px;
				    color: #f25529;
				    margin-right: 6px;
			    }
	    	}
	    	>input[type="text"] {
  		    border-radius: 3px;
			    border: solid 1px #aaaaaa;
			    background-color: #ffffff;
			    height: 40px;
			    width: 100%;
	        font-size: 14px;
			    line-height: 1.29;
			    color: #1c2b36;
			    padding: 0 14px;
			    &[readonly]{
			    	background-color: rgba(236, 236, 236, 0.5);
			    	border-color: rgba(236, 236, 236, 0.5);
			    	color: #aaaaaa;
			    }
	    	}
	    }
    }
    >.fc-control{
    	display: flex;
    	justify-content: center;
    	>a{
		    border-radius: 5px;
		    border: solid 1px #009938;
		    margin: 0 12px;
        width: 122px;
		    text-align: center;
		    height: 36px;
		    line-height: 36px;
		    font-size: 13px;
			  font-weight: bold;
			  letter-spacing: 0.9px;
			  color: #009938;
			  cursor: pointer;
			  &.fc-save{
			  	background-color:#009938;
			  	color:#fff;
			  }
    	}
    }
    >.fc-close{
    	width: 50px;
	    height: 50px;
	    position: absolute;
	    right: 0;
	    top: 0;
      display: flex;
	    justify-content: center;
	    align-items: center;
	    cursor: pointer;
	    &::before{
	    	content: "\f2c0";
		    font-family: 'Ionicons';
		    font-size: 20px;
			  text-align: center;
			  color: #009938;
	    }
    }
  }
}
@media only screen and (max-width: 767px){
.fc-checkout-edit-address{
  >div{
    padding: 24px;
    >label{
	    font-size: 14px;
    }
    >.fc-address-form{
	    margin:8px 0;
	    >div{
	    	width: 100%;
	    	&.fc-address{
	    		width: 100%;
	    	}
	    }
    }
  }
}
}
</style>


// WEBPACK FOOTER //
// src/components/checkout/EditAddress.vue